export default __webpack_public_path__ + "static/media/High Protector's Tasset.6607a0d5.jpg";